export default __webpack_public_path__ + "static/media/6.72ede113.png";